import React from 'react';
import './Loading.scss';
import loaderImage from './loader.svg';

const Loading = ({className='', ...props}) => {
    return <div className={'loader '+className} ><img src={loaderImage} alt={'Loading'}/></div>;
};

export default Loading;
